import Dialog from 'components/Popup/Dialog'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Loader from '../../../../components/Loader'
import AuthenticatedPage from '../../../../containers/AuthenticatedPage'
import { isPickingDeliveryListEnabled } from 'containers/App/fulfilmentPickingConfig'
import API from '../../../../lib/api'
import { getSession } from '../../../../lib/auth'
import { hasHalalCheckTag } from '../../../../lib/customerTags'
import { getMessage } from '../../../../lib/translator'
import MissingPage from '../../../others/MissingPage'
import { isDspSource } from '../constants/orderSource'
import {
  DspPickingOrderDetails,
  DspOrderActions,
  getPickingOrderDetailFromLocation,
  isPickingDeliveryDetailPath,
  resolvePickingOrderByReference,
} from './PickingOrderDetails'
import OrderActions from './OrderActions'
import ShowDeliveryOrderDetails from './ShowDeliveryOrderDetails'
import { buildPacklistApiUrl } from './buildPacklistApiUrl'
import {
  filterAddressByOrderType,
  normalizeCustomerProfileFromResponse,
} from './helpers.utils'
import { normalisePacklistGroups } from './poaPacklistGroups'
import { fetchPoaPacklistGroups } from './poaLinkedPacklists'
import './style.css'

function getMobileView() {
  return window.screen.width <= 480
}

function isPickingDeliveryOrdersEnabled(splits) {
  return isPickingDeliveryListEnabled(splits)
}

export default class DeliveryOrderDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      loading: false,
      failed: false,
      isMobileView: getMobileView(),
      packlistData: null,
      packlistGroups: [],
      deliveryNoteData: null,
      communicationConfig: null,
      orderConfig: null,
      error: null,
      salesOrderType: null,
      errorDialog: null,
      isHalalCheck: false,
      customerAddresses: null,
      customerProfileSummary: null,
      dspPickingOrderDetail: null,
      packlistLoading: false,
      dspResolveFailed: false,
      dspIsEditingPacked: false,
      dspFeatureDisabled: false,
    }
    this.getMobileView = this.getMobileView.bind(this)
    this.organization = getSession().organization
    this.getData = this.getData.bind(this)
    this.getPacklistData = this.getPacklistData.bind(this)
    this.initDspPickingView = this.initDspPickingView.bind(this)
    this.loadDbpOrder = this.loadDbpOrder.bind(this)
    this.poaGroupsRequestId = 0
  }

  getMobileView() {
    this.setState({ isMobileView: window.screen.width <= 480 })
  }

  onError(error) {
    if (error && error.message) {
      this.setState({
        error: error.message.split(':').slice(1).join(':'),
      })
    }
    throw error
  }

  getOrderDetailsApi() {
    return this.orderDetailsApi.get({}).then(
      async (response) => {
        const deliveryNote = {
          referenceNumber: response.deliveryOrder.referenceNumber,
          customerNote: response.deliveryOrder.customerInstruction,
          dispatcherNote: response.deliveryOrder.dispatcherInstruction,
          deliveryNotes: response.deliveryOrder.deliveryNotes,
        }
        const deliveryOrder = filterAddressByOrderType(response)
        let salesOrderOrders = response.salesOrder?.orders
        const salesOrderReferenceNumber =
          response.deliveryOrder?.salesOrderReferenceNumber

        if (!salesOrderOrders?.length && salesOrderReferenceNumber) {
          this.salesOrderDetailsApi = new API({
            url: `/order-service/v3/salesOrders/${salesOrderReferenceNumber}?excludeCustomerDetails=true`,
          })
          try {
            const salesOrderResponse = await this.salesOrderDetailsApi.get()
            salesOrderOrders = salesOrderResponse.salesOrder?.orders
          } catch {
            salesOrderOrders = null
          }
        }

        if (salesOrderOrders?.length) {
          deliveryOrder.salesOrderOrders = salesOrderOrders
        }
        this.setState({
          failed: false,
          data: deliveryOrder,
          deliveryNoteData: deliveryNote,
          salesOrderType: response.salesOrder?.type,
        })

        const customerId =
          response.deliveryOrder?.customerId ||
          response.deliveryOrder?.customer?.id
        if (customerId && Number(customerId) !== 0) {
          this.fetchCustomerTags(customerId)
          this.fetchCustomerAddresses(customerId)
        } else {
          this.setState({ customerAddresses: [], customerProfileSummary: null })
        }
      },
      (error) => {
        this.setState({ failed: true })
        if (error.code === 401) {
          throw error
        }
      }
    )
  }

  fetchCustomerTags(customerId) {
    this.customerTagsApi = new API({
      url: `/ef-customer-core/profile/${customerId}/tags`,
    })
    this.customerTagsApi
      .get()
      .then((response) => {
        const tags = response?.data?.tags || []
        this.setState({ isHalalCheck: hasHalalCheckTag(tags) })
      })
      .catch(() => {
        this.setState({ isHalalCheck: false })
      })
  }

  fetchCustomerTagsForPickingOrder(orderId) {
    if (orderId === undefined || orderId === null || orderId === '') {
      this.setState({ isHalalCheck: false })
      return
    }

    this.pickingOrderTagsApi = new API({
      url: '/picking-service/v3/orderDetails',
    })
    this.pickingOrderTagsApi
      .get({ orderId, pageSize: 1 })
      .then((response) => {
        const customerTags = response?.orderDetails?.[0]?.customerTags || []
        this.setState({ isHalalCheck: hasHalalCheckTag(customerTags) })
      })
      .catch(() => {
        this.setState({ isHalalCheck: false })
      })
  }

  setIsHalalCheckFromCustomerTags(customerTags) {
    this.setState({ isHalalCheck: hasHalalCheckTag(customerTags || []) })
  }

  fetchCustomerAddresses(customerId) {
    this.customerAddressesApi = new API({
      url: `/ef-customer-core/profile/${customerId}?fullresponse=true`,
    })
    this.customerAddressesApi
      .get()
      .then((response) => {
        const { addresses, customerProfileSummary } =
          normalizeCustomerProfileFromResponse(response, customerId)
        this.setState({ customerAddresses: addresses, customerProfileSummary })
      })
      .catch(() => {
        this.setState({ customerAddresses: [], customerProfileSummary: null })
      })
  }

  getPacklistAPI() {
    return this.packlistApi
      .get({})
      .then((response) => {
        // packlistData stays scoped to the order that was opened — every write path
        // (assign picker, edit packed, print labels) reads it. Groups are additive and
        // display-only.
        const { ownPacklists, groups, isRecognised } = normalisePacklistGroups(
          response,
          {
            currentDeliveryOrderNo: this.props.router.match.params.id,
            orderId: this.state.dspPickingOrderDetail?.orderId,
          }
        )
        if (!isRecognised) {
          // Empty message so the catch falls back to the generic fetch-error copy.
          throw new Error()
        }
        this.setState({
          failed: false,
          packlistData: ownPacklists,
          packlistGroups: groups,
        })
        this.loadPoaPacklistGroups()
      })
      .catch((error) => {
        this.setState({
          errorDialog: {
            title:
              error?.message ||
              getMessage('order.details.packlist.fetch.error.title'),
            message: getMessage('order.details.packlist.fetch.error.message'),
          },
        })
      })
  }

  // The linked POA orders' packlists (LIT-541) come from a separate, display-only call so
  // the opened order's own packlists and every action on them stay exactly as they are.
  // A failure only means the linked section is not shown — it never blocks the page.
  loadPoaPacklistGroups() {
    this.poaGroupsRequestId += 1
    const requestId = this.poaGroupsRequestId
    const order = this.state.dspPickingOrderDetail
    fetchPoaPacklistGroups(order)
      .then((rawGroups) => {
        if (!rawGroups || requestId !== this.poaGroupsRequestId) {
          return
        }
        const { groups } = normalisePacklistGroups(
          { packlistGroups: rawGroups },
          {
            currentDeliveryOrderNo: this.props.router.match.params.id,
            orderId: order?.orderId,
          }
        )
        this.setState({ packlistGroups: groups })
      })
      .catch(() => {})
  }

  getData() {
    const referenceNumber = this.props.router.match.params.id
    this.orderDetailsApi = new API({
      url: `/order-service/v3/deliveryOrders/${referenceNumber}?excludeCustomerDetails=true`,
    })
    this.setState(
      {
        loading: true,
        failed: false,
        customerAddresses: null,
        customerProfileSummary: null,
      },
      () => {
        this.getOrderDetailsApi().then(() => {
          this.setState({ loading: false })
        })
      }
    )
  }

  getPacklistData({ skipPageLoading = false, pickingOrderDetail = null } = {}) {
    const referenceNumber = this.props.router.match.params.id
    const dspOrder =
      pickingOrderDetail || this.state.dspPickingOrderDetail || null
    this.packlistApi = new API({
      url: buildPacklistApiUrl({
        referenceNumber,
        orderId: dspOrder?.orderId,
        source: dspOrder?.source,
      }),
    })
    this.setState(
      {
        ...(skipPageLoading
          ? { packlistLoading: true }
          : { loading: true, failed: false }),
      },
      () => {
        this.getPacklistAPI().then(() => {
          this.setState(
            skipPageLoading ? { packlistLoading: false } : { loading: false }
          )
        })
      }
    )
  }

  getCommunicationConfig() {
    this.communicationApi = new API({ url: `/account-service/config` })
    this.communicationApi
      .get()
      .then((response) => {
        this.setState({
          communicationConfig: response.data.config.communication,
          orderConfig: response.data.config.order,
        })
      })
      .catch((error) => {
        throw error
      })
  }

  async componentDidMount() {
    window.addEventListener('resize', this.mobileView, false)

    const pickingOrderDetail = getPickingOrderDetailFromLocation(
      this.props.location
    )
    if (pickingOrderDetail) {
      if (isDspSource(pickingOrderDetail.source)) {
        if (!isPickingDeliveryOrdersEnabled(this.props.splits)) {
          this.setState({
            loading: false,
            failed: false,
            dspFeatureDisabled: true,
          })
          return
        }
        this.initDspPickingView(pickingOrderDetail)
        return
      }
      this.loadDbpOrder()
      return
    }

    // Direct load / refresh: no router state.
    // Legacy delivery-orders is DBP-only — skip picking-service orderDetails.
    // Picking-delivery-orders resolves source/orderId from picking-service.
    const referenceNumber = this.props.router.match.params.id
    const onPickingRoute = isPickingDeliveryDetailPath(
      this.props.location?.pathname
    )
    if (!onPickingRoute) {
      this.loadDbpOrder()
      return
    }

    this.setState({ loading: true, failed: false })
    try {
      const resolved = await resolvePickingOrderByReference(referenceNumber)
      if (resolved && isDspSource(resolved.source)) {
        if (!isPickingDeliveryOrdersEnabled(this.props.splits)) {
          this.setState({
            loading: false,
            failed: false,
            dspFeatureDisabled: true,
          })
          return
        }
        this.initDspPickingView(resolved)
        return
      }
      if (resolved && !isDspSource(resolved.source)) {
        this.loadDbpOrder()
        return
      }
      this.setState({ loading: false, failed: false, dspResolveFailed: true })
    } catch {
      this.setState({ loading: false, failed: false, dspResolveFailed: true })
    }
  }

  initDspPickingView(pickingOrderDetail) {
    this.setState({
      dspPickingOrderDetail: pickingOrderDetail,
      loading: false,
      failed: false,
      dspResolveFailed: false,
    })
    this.getPacklistData({ skipPageLoading: true, pickingOrderDetail })
    if (pickingOrderDetail?.customerTags !== undefined) {
      this.setIsHalalCheckFromCustomerTags(pickingOrderDetail.customerTags)
    } else {
      this.fetchCustomerTagsForPickingOrder(pickingOrderDetail?.orderId)
    }
  }

  loadDbpOrder() {
    this.getData()
    this.getPacklistData()
    this.getCommunicationConfig()
  }

  componentWillUnmount() {
    // Drops any in-flight linked-packlist response instead of setting state after unmount.
    this.poaGroupsRequestId += 1
    this.orderDetailsApi && this.orderDetailsApi.cancel()
    this.packlistApi && this.packlistApi.cancel()
    this.salesOrderDetailsApi && this.salesOrderDetailsApi.cancel()
    this.communicationApi && this.communicationApi.cancel()
    this.customerTagsApi && this.customerTagsApi.cancel()
    this.pickingOrderTagsApi && this.pickingOrderTagsApi.cancel()
    this.customerAddressesApi && this.customerAddressesApi.cancel()
    window.removeEventListener('resize', this.mobileView, false)
  }

  render() {
    if (this.state.dspFeatureDisabled) {
      return <MissingPage />
    }

    const { isMobileView, isOrderViewItemCollapsed, isDeliveryNoteCollapsed } =
      this.state
    const referenceNumber = this.props.router.match.params.id
    const isDspPickingOrder = Boolean(this.state.dspPickingOrderDetail)
    const onPickingRoute = isPickingDeliveryDetailPath(
      this.props.location?.pathname
    )
    const referenceDetailPath =
      isDspPickingOrder || onPickingRoute
        ? `/operations/picking-delivery-orders/${referenceNumber}`
        : `/operations/delivery-orders/${referenceNumber}`
    const contentLoaded =
      !this.state.loading &&
      !this.state.failed &&
      this.state.data &&
      this.state.packlistData

    return (
      <AuthenticatedPage
        storeDependent={this.props.url === '/operations'}
        className={`delivery-order-details${
          isDspPickingOrder ? ' dsp-picking-order-details' : ''
        }`}
        menu={this.props.menu}
      >
        <div className="flex-around">
          <h1 className="title heading">
            {isDspPickingOrder
              ? getMessage('picking.orderDetail.dsp.page.title')
              : this.state.salesOrderType === 'SALES_ORDER_TYPE_SCAN_AND_GO' ||
                  this.state.salesOrderType === 'SALES_ORDER_TYPE_RB_PREORDER'
                ? getMessage('order.details.heading')
                : getMessage('deliveryOrder.details.heading')}
            &nbsp;
            {getMessage('order.table.referenceNumber.prefix')}
            <Link to={referenceDetailPath}>
              <strong className="reference-number">{referenceNumber}</strong>
            </Link>
          </h1>
          {contentLoaded && !isDspPickingOrder && (
            <OrderActions
              data={this.state.data}
              packlistData={this.state.packlistData}
              salesOrderType={this.state.salesOrderType}
              reloadDetails={() => window.location.reload()}
              referenceNumber={referenceNumber}
              isHalalCheck={this.state.isHalalCheck}
              usePickingDeliveryOrdersPaths={onPickingRoute}
            />
          )}
          {isDspPickingOrder ? (
            <div
              className="order-actions"
              data-testid="dsp-order-header-actions"
            >
              <DspOrderActions
                order={this.state.dspPickingOrderDetail}
                packlistData={this.state.packlistData || []}
                usePickingDeliveryOrdersPaths={onPickingRoute}
                onReload={() =>
                  this.getPacklistData({
                    skipPageLoading: true,
                    pickingOrderDetail: this.state.dspPickingOrderDetail,
                  })
                }
                isHalalCheck={this.state.isHalalCheck}
                isEditingPacked={this.state.dspIsEditingPacked}
                onStartEditPacked={() =>
                  this.setState({ dspIsEditingPacked: true })
                }
              />
            </div>
          ) : null}
        </div>

        {this.state.loading ? <Loader /> : null}
        {this.state.failed ? (
          <div className="retry-message text-muted" onClick={this.getData}>
            {getMessage('order.details.errors.onLoad')}
          </div>
        ) : null}

        {this.state.dspResolveFailed ? (
          <div className="retry-message text-muted">
            {getMessage('picking.orderDetail.dsp.resolve.error')}
            &nbsp;
            <Link to="/operations/picking-delivery-orders">
              {getMessage('picking.orderDetail.dsp.backToList')}
            </Link>
          </div>
        ) : null}

        {isDspPickingOrder ? (
          <DspPickingOrderDetails
            order={this.state.dspPickingOrderDetail}
            packlistData={this.state.packlistData}
            packlistGroups={this.state.packlistGroups}
            packlistLoading={this.state.packlistLoading}
            currency={this.organization.currency}
            listPath="/operations/picking-delivery-orders"
            isHalalCheck={this.state.isHalalCheck}
            isEditingPacked={this.state.dspIsEditingPacked}
            onStartEditPacked={() =>
              this.setState({ dspIsEditingPacked: true })
            }
            onStopEditPacked={() =>
              this.setState({ dspIsEditingPacked: false })
            }
            onReload={() =>
              this.getPacklistData({
                skipPageLoading: true,
                pickingOrderDetail: this.state.dspPickingOrderDetail,
              })
            }
          />
        ) : null}

        {contentLoaded ? (
          <ShowDeliveryOrderDetails
            deliveryOrderData={this.state.data}
            packlistData={this.state.packlistData}
            deliveryNoteData={this.state.deliveryNoteData}
            url={this.props.url}
            isMobileView={isMobileView}
            isOrderViewItemCollapsed={isOrderViewItemCollapsed}
            isDeliveryNoteCollapsed={isDeliveryNoteCollapsed}
            currency={this.organization.currency}
            communicationConfig={this.state.communicationConfig}
            orderConfig={this.state.orderConfig}
            error={this.state.error}
            router={this.props.router}
            salesOrderType={this.state.salesOrderType}
            onError={() => this.onError()}
            getOrderDetailsApi={() => this.getOrderDetailsApi()}
            customerAddresses={this.state.customerAddresses}
            customerProfileSummary={this.state.customerProfileSummary}
          ></ShowDeliveryOrderDetails>
        ) : null}

        {this.state.errorDialog && (
          <Dialog
            show={!!this.state.errorDialog}
            title={this.state.errorDialog.title}
            information={this.state.errorDialog.message}
            close={() => this.setState({ errorDialog: null })}
            closeText={getMessage('dialog.okText')}
          />
        )}
      </AuthenticatedPage>
    )
  }
}
